/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 10:07:46
 * @LastEditTime: 2022-04-19 10:19:14
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionDetail/config.ts
 */
export const breadcrumbData = (name, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/orderList',
    name: getI18n(
      'reportSubscription.reportSubscriptionDetail.reportSusbcription',
    ),
  },
  {
    url: '',
    name: `${
      name ||
      getI18n(
        'reportSubscription.reportSubscriptionDetail.addReportSusbcription',
      )
    }`,
  },
];
